import React from "react";

const ChevronIcon = () => (
  <svg
    width="11"
    height="18"
    viewBox="0 0 11 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      d="M7.5858 9.00008L0.292908 1.70718L1.70712 0.292969L10.4142 9.00008L1.70712 17.7072L0.292908 16.293L7.5858 9.00008Z"
    />
  </svg>
);

export default ChevronIcon;
